module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEzVjdNMTQgMTNWN00xMiAxN1YyMU04IDIxSDE2TTQgM0gyMEMyMS4xMDQ2IDMgMjIgMy44OTU0MyAyMiA1VjE1QzIyIDE2LjEwNDYgMjEuMTA0NiAxNyAyMCAxN0g0QzIuODk1NDMgMTcgMiAxNi4xMDQ2IDIgMTVWNUMyIDMuODk1NDMgMi44OTU0MyAzIDQgM1oiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/iconesManutencao/Icones_-_Abas_Sicarf/file-suspender.svg
// module id = DGwp
// module chunks = 12